import { axiosSarlaft } from "@/plugins/axios";
import type { AxiosResponse } from "axios";

export const departmentService = {
  getAll: async (): Promise<any> => {
    try {
      const response = await axiosSarlaft.get(`/departamentos`, {});
      const data = await response.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
  getDepartmentsByCountry: async (id: string): Promise<any> => {
    //const key = String(id);

    // Revisar si está en cache
    // if (fileService.cache.has(key)) {
    //   return fileService.cache.get(key);
    // }

    // Si no está, pedir al backend
    const response: AxiosResponse<any, any> = await axiosSarlaft.get(
      `/departamentos/${id}`
    );
    const data = response.data;

    // Guardar en cache para próximas llamadas
    // fileService.cache.set(key, data);

    return data;
  },
};
